import { render } from "./orderAndScreen.vue?vue&type=template&id=6c69119a&scoped=true"
import script from "./orderAndScreen.vue?vue&type=script&lang=js"
export * from "./orderAndScreen.vue?vue&type=script&lang=js"

import "./orderAndScreen.vue?vue&type=style&index=0&id=6c69119a&scoped=true&lang=scss"
import "./orderAndScreen.vue?vue&type=style&index=1&id=6c69119a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c69119a"]])

export default __exports__